import React, { useState } from "react";
import { View } from "react-native";
import type { Meta, StoryObj } from "@storybook/react";
import OptionsField from "../../components/OptionsField";

function StoryComponent() {
    const [value, setValue] = useState<boolean | undefined>(undefined);

    return (
        <OptionsField
            value={value}
            onSelect={setValue}
            label="Do you like this field"
            data={[
                { label: "TRUE", value: true },
                { label: "FALSE", value: false },
            ]}
        />
    );
}

const meta = {
    title: "Fields/Options",
    component: StoryComponent,
    argTypes: {},
    decorators: [
        (StoryFn) => (
            <View style={{ alignItems: "stretch", padding: 10 }}>
                <StoryFn />
            </View>
        ),
    ],
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {},
};
